import { http } from "../api/http";
import Utils from "../utils";

export const clientVariableLineService = {
  get,
  create,
  remove,
  update,
  getPicklistValues,
  setPicklistValues,
  getLineType,
  setLineType,
  getRuntimeOverridable,
  setRuntimeOverridable,
};

function get(requestParameters) {
  let url = `/clientvariableline?${Utils.objectToQueryString(
    requestParameters
  )}`;

  return http.get(url).then((response) => {
    return response;
  });
}

function create(requestBody) {
  let url = `/clientvariableline/create`;

  return http.post(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

function remove(requestParameters) {
  let url = `/clientvariableline/delete?${Utils.objectToQueryString(
    requestParameters
  )}`;

  return http.delete(url).then((response) => {
    return response;
  });
}

function update(requestBody) {
  let url = `/clientvariableline/update`;

  return http.patch(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

// #2608: picklist values are owned by the one line they suggest values for (not a separate,
// reusable, named Picklist -- that design was tried and reverted). Local-only -- unlike
// create/update above, which proxy to the external Master Runbook Service (see #2607), this
// writes straight to this API's own DB.
function getPicklistValues(requestParameters) {
  let url = `/clientvariableline/picklistvalues?${Utils.objectToQueryString(requestParameters)}`;

  // Same class of bug as #2583/#2660/foruser: fetched automatically for every Picklist-type
  // line the moment the Execute confirm dialog opens (RunbookGrid's run button handler) --
  // confirmed via live repro (#2666 logout investigation) that this 401s for some client users
  // while the equivalent runbooktag/foruser lookups alongside it do not, and unlike those it
  // wasn't opted out yet, so it was the one actually forcing the logout. A 401 here just means
  // this picklist's options can't be shown, not that the session is dead. See the
  // skipAuthRedirect comment in api/http.js.
  return http.get(url, { skipAuthRedirect: true }).then((response) => {
    return response;
  });
}

function setPicklistValues(requestBody) {
  let url = `/clientvariableline/picklistvalues`;

  return http.put(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

// #2610: same local-only pattern as picklist values above -- LineType never touches the
// Master Runbook Service proxy.
function getLineType(requestParameters) {
  let url = `/clientvariableline/linetype?${Utils.objectToQueryString(requestParameters)}`;

  return http.get(url).then((response) => {
    return response;
  });
}

function setLineType(requestBody) {
  let url = `/clientvariableline/linetype`;

  return http.put(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

// #2618: same local-only pattern as linetype above.
function getRuntimeOverridable(requestParameters) {
  let url = `/clientvariableline/runtimeoverridable?${Utils.objectToQueryString(requestParameters)}`;

  return http.get(url).then((response) => {
    return response;
  });
}

function setRuntimeOverridable(requestBody) {
  let url = `/clientvariableline/runtimeoverridable`;

  return http.put(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}
